(function(){
  'strict mode'
  $(function() {

    var dangerTemp = 135,
        $tankWaterTemp = $('#tankWaterTemp'),
        $agreeCheckbox = $('#agreeTemp'),
        $saveButton = $('#btnApplyOptions');

    //Restrict Input to upper value specificed on data-max
    //On keyup we can change the value to be less than the max
    $('[data-max]').on('keyup change', function(){
      var $this = $(this);
      var userSetting = $this.val();
      limitUpperInputValue(userSetting, $this.data('max'), $this);
    });

    //Restrict Input to lower value specificed on data-min
    //For the min limit we need to wait until they are done typing
    $('[data-min]').on('change', function(){
      var $this = $(this);
      var userSetting = $this.val();
      limitLowerInputValue(userSetting, $this.data('min'), $this);
    });


    //Handle Too High Tank Temp Warning Message
    $tankWaterTemp.on('keyup click', function(e){
      checkUserInputForWarning($(this).val());
    });

    $('#modalAdvancedOptions').on('show.bs.modal', function(e){
      checkUserInputForWarning($tankWaterTemp.val());
    });

    $agreeCheckbox.on('change', function(e){
      $saveButton.prop( "disabled", !userHasAgreed());
    });

    function checkUserInputForWarning(value) {
      if(value > dangerTemp){
        displayWarning(value);
      }else {
        hideWarning();
      }
    }



    function displayWarning(temp) {
      $tankWaterTemp.addClass('warning');
      $agreeCheckbox.prop( "checked", false );
      $saveButton.prop( "disabled", true );
      $('#tempVal').text(temp);
      $('.temp-warning').show();
    }


    function hideWarning() {
      $saveButton.prop( "disabled", false );
      $tankWaterTemp.removeClass('warning');
      $('.temp-warning').hide();
    }

    function userHasAgreed() {
      return $('#agreeTemp:checked').length > 0;
    }

    //Do upper and lower limit seperatle since we check them on differnt events
    //Upper limit checked on keyup
    function limitUpperInputValue(val, max, $node) {
      val = val > max ? max : val;
      $node.val(val);
      return val;
    }

    //Lower limit checked on change
    function limitLowerInputValue(val, min, $node) {
      val = val < min || !val ? min : val;
      $node.val(val);
      return val;
    }

  });
}());
